import { OwnerPatrimonyRequestStatus } from "../types/ownerDashboard.types";

export function isOwnerRequestPending(
  status: OwnerPatrimonyRequestStatus,
  shouldFetch: boolean
): boolean {
  if (!shouldFetch) {
    return false;
  }

  return status === "idle" || status === "loading";
}
